<div class="container not-found">
  <header class="page-heading mb-lg">
    <span class="about-eyebrow">404</span>
    <h1>Page not found</h1>
    <p>
      The page you're looking for doesn't exist, may have moved, or the link may be mistyped.
      Here are a few places to go instead.
    </p>
  </header>

  <section class="card mb-lg">
    <h2 class="section-title">Popular calculators</h2>
    <div class="not-found-links">
      <a routerLink="/home-loan">Home Loan EMI Calculator</a>
      <a routerLink="/sip">SIP Calculator</a>
      <a routerLink="/income-tax">Income Tax Calculator</a>
      <a routerLink="/ppf">PPF Calculator</a>
      <a routerLink="/fd">FD Calculator</a>
      <a routerLink="/fire">FIRE Calculator</a>
    </div>
  </section>

  <p><a routerLink="/">&larr; Back to the homepage</a></p>
</div>
